import { AlertCircle } from "lucide-react";

type Props = {
  message?: string | null;
  onRetry?: () => void;
};

export function LeaveError({ message, onRetry }: Props) {
  return (
    <div className="flex items-start gap-3 rounded-2xl border border-red-200 bg-red-50 p-4">
      <AlertCircle className="mt-0.5 h-5 w-5 shrink-0 text-red-500" />
      <div className="flex-1">
        <p className="font-semibold text-red-800">Something went wrong</p>
        <p className="mt-0.5 text-sm text-red-600">{message || "An unexpected error occurred."}</p>
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="shrink-0 rounded-xl border border-red-200 bg-white px-3 py-1.5 text-xs font-semibold text-red-700 shadow-sm transition hover:bg-red-50"
        >
          Retry
        </button>
      )}
    </div>
  );
}
